import SectionHeading from '@/pages/home/components/SectionHeading';
import { ranking } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热度榜"
          title="本周人物关注榜"
          desc="按合集浏览与关系路径引用情况排出的人物榜，前三名通常是当前事件的核心当事人。"
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {ranking.map((item, index) => (
            <div
              key={item.name}
              className={`flex items-center gap-4 px-4 py-4 md:px-6 ${
                index !== ranking.length - 1 ? 'border-b border-background-100' : ''
              }`}
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                }`}
              >
                {item.rank}
              </span>

              <div className="w-20 shrink-0 md:w-32">
                <h4 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.name}</h4>
                <p className="font-label text-[11px] text-foreground-500">{item.role}</p>
              </div>

              <div className="hidden flex-1 md:block">
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className="h-full rounded-full bg-accent-500" style={{ width: `${item.score}%` }} />
                </div>
              </div>

              <span className="hidden whitespace-nowrap font-label text-xs text-foreground-500 lg:block">{item.topic}</span>

              <span className="ml-auto font-heading text-lg font-bold text-primary-600 md:ml-0">{item.score}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}